/* Keeps the YourToken "Reward" launcher on the same horizontal line as the
 * Verifast chat avatar. Verifast is positioned by its own dashboard (120px
 * from the bottom on phones, 150px on desktop at the time of writing), so
 * this reads the chat iframe's real `bottom` and exposes it as
 * --oh-vf-bottom; yt-app.css places the Reward pill from that value.
 * If Verifast is missing, the CSS fallbacks in yt-app.css apply. */
(() => {
  const root = document.documentElement;
  let watched = null;
  const sync = () => {
    const f = document.getElementById('verifast-react-chatbot-iframe');
    if (!f) return false;
    const b = parseFloat(f.style.bottom || getComputedStyle(f).bottom);
    if (!isNaN(b)) root.style.setProperty('--oh-vf-bottom', b + 'px');
    if (watched !== f) {
      watched = f;
      new MutationObserver(sync).observe(f, { attributes: true, attributeFilter: ['style'] });
    }
    return true;
  };
  if (sync()) return;
  const mo = new MutationObserver(() => { if (sync()) mo.disconnect(); });
  const start = () => mo.observe(document.body, { childList: true, subtree: true });
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
  setTimeout(() => mo.disconnect(), 30000);
})();